const backendAddress = "http://localhost:3001/"

export default backendAddress;
